import { render, staticRenderFns } from "./UserWidget.vue?vue&type=template&id=656d2ea4&scoped=true&"
import script from "./UserWidget.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserWidget.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserWidget.vue?vue&type=style&index=0&id=656d2ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d2ea4",
  null
  
)

export default component.exports